import { Component } from '@angular/core';
import { IonicPage, NavController, LoadingController, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { AuthenticationApi } from '../../services/authentication/authentication-api';
import { LoginPage } from '../login/login';

@IonicPage({
  name: "forgot",
  segment: "forgot"
})
@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {
  public forgotPasswordForm: FormGroup;
  public email: FormControl;
  public completed: Boolean = false;

  home() {
    this.navCtrl.push(LoginPage)
  }

  sendEmail(value) {

    let self: ForgotPasswordPage = this;

    let loading = this.loadingCtrl.create({ content: 'Sending Email...' });
    loading.present();

    this.authApi.forgot(value.email).subscribe(res => {
      self.completed = true;
      self.storage.setItem("reset-password-email",value.email).subscribe(() => {
        loading.dismiss();
        let toast = self.toastCtrl.create({ message: res.message, duration: 9000, position: "top"});
        toast.present();
      });
    },rej => {
      loading.dismiss();
      let toast = self.toastCtrl.create({ message: rej.message, duration: 9000, position: "top"});
      toast.present();
    });
  }

  constructor( public navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private fb: FormBuilder,
    private authApi: AuthenticationApi,
    private toastCtrl: ToastController,
    private storage: AsyncLocalStorage) {
      this.email = this.fb.control('', Validators.compose([Validators.required]));
      this.forgotPasswordForm = this.fb.group({ email: this.email });
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts